import axiosInstance from '../../axios-config';

const getReminderSettingsUrl = '/api/systemremindersettings';
const patientReminderSettingsUrl = '/api/patients/{0}/NotificationSettings';

export const getReminderSettings = () => axiosInstance.get(getReminderSettingsUrl);

export const getPatientReminderSettings = (patientId) =>
  axiosInstance.get(patientReminderSettingsUrl.replace('{0}', patientId));

export const putPatientReminderSettings = (patientId, patientReminderSettings) =>
  axiosInstance.put(
    patientReminderSettingsUrl.replace('{0}', patientId),
    patientReminderSettings,
    { headers: { 'Content-Type': 'application/json' } }
  );
